const uploadFile = async (fileWithMeta) => {
  const file = fileWithMeta.rawFile;
  const key = fileWithMeta.title;

  if (!file || !key) {
    console.error("uploadFile requires an object with rawFile and title.");
    return null;
  }

  console.log("Starting upload for file:", {
    fileName: file.name,
    fileSize: file.size,
    fileType: file.type,
    s3Key: key
  });

  try {
    const [prefix, ...filePathParts] = key.split("/");
    const fileName = filePathParts.join("/");

    if (!prefix || !fileName) {
      throw new Error(`Invalid S3 key format: ${key}`);
    }

    const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:1337";
    console.log("Using API URL:", apiUrl);

    // Get token from local storage
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No authentication token found");
    }

    // 1. Get pre-signed URL from backend
    const presignedUrlRequest = `${apiUrl}/assets/upload-url?file=${encodeURIComponent(
      fileName
    )}&contentType=${encodeURIComponent(file.type)}&prefix=${prefix}`;
    
    console.log("Requesting presigned URL:", presignedUrlRequest);
    
    const presignedUrlResponse = await fetch(presignedUrlRequest, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Presigned URL response status:", presignedUrlResponse.status);

    if (!presignedUrlResponse.ok) {
      const errorBody = await presignedUrlResponse.text();
      console.error("Presigned URL request failed:", {
        status: presignedUrlResponse.status,
        statusText: presignedUrlResponse.statusText,
        body: errorBody
      });
      throw new Error(
        `Failed to get pre-signed URL: ${presignedUrlResponse.statusText}. Body: ${errorBody}`
      );
    }

    const presignedData = await presignedUrlResponse.json();
    console.log("Presigned URL response data:", presignedData);

    const { uploadUrl } = presignedData;

    if (!uploadUrl) {
      throw new Error("Backend did not return an uploadUrl");
    }

    // 2. Upload file to S3 using the pre-signed URL
    console.log("Uploading to S3 with presigned URL:", uploadUrl);
    
    const uploadResponse = await fetch(uploadUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });

    console.log("S3 upload response status:", uploadResponse.status);

    if (!uploadResponse.ok) {
      const errorBody = await uploadResponse.text();
      console.error("S3 upload failed:", {
        status: uploadResponse.status,
        statusText: uploadResponse.statusText,
        body: errorBody
      });
      throw new Error(
        `S3 upload failed: ${uploadResponse.statusText}. Body: ${errorBody}`
      );
    }

    // 3. Return the public URL of the uploaded file
    const publicUrl = uploadUrl.split("?")[0];
    console.log("Upload successful:", publicUrl);
    return publicUrl;
  } catch (err) {
    console.error("Error during file upload:", {
      fileName: key,
      error: err.message,
      stack: err.stack
    });
    throw err;
  }
};

const upload = async (files) => {
  console.log("Starting batch upload for", files.length, "files");
  
  try {
    const uploadPromises = files.map((file) => uploadFile(file));
    const results = await Promise.all(uploadPromises);
    console.log("Batch upload completed successfully:", results);
    return results;
  } catch (error) {
    console.error("Batch upload failed:", error);
    throw error;
  }
};

const s3Service = {
  upload,
};

export default s3Service;
